import { __assign, __read, __rest } from "tslib";
import React, { useState, useImperativeHandle, useEffect, forwardRef, useRef, } from "react";
import classNames from "classnames";
import ReactDOM, { unmountComponentAtNode, createPortal } from "react-dom";
import { useConfig } from "../_util/config-context";
import { Icon } from "../icon";
import { ConfigProvider } from "../configprovider";
import { useVisibleTransition } from "../_util/use-visible-transition";
import { callBoth } from "../_util/call-both";
import { noop } from "../_util/noop";
import { getRoot, MessageTransition, limit } from "./util";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
var Message = forwardRef(function MessageShow(_a, ref) {
    var type = _a.type, content = _a.content, _b = _a.duration, duration = _b === void 0 ? 3000 : _b, className = _a.className, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.onClose, onClose = _d === void 0 ? noop : _d;
    var classPrefix = useConfig().classPrefix;
    var _e = __read(useState(false), 2), visible = _e[0], setVisible = _e[1];
    useImperativeHandle(ref, function () { return ({ setVisible: setVisible }); });
    var timerRef = useRef(null);
    // 渲染之后，马上显示
    useEffect(function () {
        setVisible(true);
        return function () { return clearTimeout(timerRef.current); };
    }, []);
    useIsomorphicLayoutEffect(function () {
        clearTimeout(timerRef.current);
        if (visible && duration !== 0) {
            timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
        }
    }, [duration, visible]);
    var _f = useVisibleTransition(visible), shouldContentEnter = _f.shouldContentEnter, shouldContentRender = _f.shouldContentRender, onContentExit = _f.onContentExit;
    if (!shouldContentRender) {
        return null;
    }
    var message = (React.createElement(MessageTransition, { in: shouldContentEnter, onExited: callBoth(onClose, onContentExit) },
        React.createElement("div", { className: classNames(classPrefix + "-toast", className), style: __assign({ zIndex: 1100 }, style), onMouseEnter: function () { return clearTimeout(timerRef.current); }, onMouseLeave: function () {
                if (duration !== 0) {
                    timerRef.current = setTimeout(function () { return setVisible(false); }, duration);
                }
            } },
            React.createElement(Icon, { type: type }),
            React.createElement("span", null, content))));
    return createPortal(message, getRoot(classPrefix));
});
Message.displayName = "Message";
var showMethod;
/**
 * API 的方式显示通知
 */
function show(type, _a) {
    if (type === void 0) { type = "success"; }
    if (_a === void 0) { _a = { content: "" }; }
    var _b = _a.onClose, onClose = _b === void 0 ? noop : _b, options = __rest(_a, ["onClose"]);
    if (typeof showMethod === "function") {
        return showMethod(type, options);
    }
    var el = document.createElement("div");
    var instanceRef = React.createRef();
    ReactDOM.render(React.createElement(ConfigProvider, null,
        React.createElement(Message, __assign({}, options, { type: type, ref: instanceRef, onClose: function () {
                onClose();
                unmountComponentAtNode(el);
            } }))), el);
    var hide = function () {
        if (instanceRef.current) {
            instanceRef.current.setVisible(false);
        }
    };
    var handle = {
        hide: hide,
        destroy: hide,
    };
    limit(handle);
    return handle;
}
export var message = {
    success: function (options) { return show("success", options); },
    warning: function (options) { return show("warning", options); },
    error: function (options) { return show("error", options); },
    loading: function (options) { return show("loading", options); },
};
// eslint-disable-next-line dot-notation
message["setShowMethod"] = function (method) {
    showMethod = method;
};
//# sourceMappingURL=Message.js.map